"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATA_TEST_IDS = void 0;
var DATA_TEST_IDS;
(function (DATA_TEST_IDS) {
    DATA_TEST_IDS["TASK_LIST_DESCRIPTION"] = "TaskListDescription";
    DATA_TEST_IDS["TASK_LIST_DESCRIPTION_LEARN_MORE"] = "TaskListDescriptionLearnMore";
    DATA_TEST_IDS["TASK_LIST_DESCRIPTION_MODAL"] = "TaskListDescriptionModal";
    DATA_TEST_IDS["TASK_LIST_DESCRIPTION_MODAL_CLOSE_BTN"] = "TaskListDescriptionModalCloseBtn";
})(DATA_TEST_IDS = exports.DATA_TEST_IDS || (exports.DATA_TEST_IDS = {}));
